import StaticInfoCardItem from "./StaticInfoCardItem";

const StaticInfoCardColumn = ({ staticInfoColumnDataList, onCollapseSubTitle }) => {
  return (
    <div className="static-info-card-column">
      {staticInfoColumnDataList.map((data, i) => (
        <StaticInfoCardItem key={i} staticInfoCardData={data} onCollapse={onCollapseSubTitle} />
      ))}
    </div>
  );
};

export default StaticInfoCardColumn;
